import { createBrowserClient } from "@supabase/ssr";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || "https://ljmgwpywfemecqbnftxm.supabase.co";
const supabaseKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || "sb_publishable_JCRHq92_4bCgp6yYm2XJuA_LbMpV5GE";

export const supabase = createBrowserClient(supabaseUrl, supabaseKey);
